import { type ReactNode } from 'react';

export function StatusToast({ children, tone = 'info' }: { children: ReactNode; tone?: 'info' | 'error' | 'success' }) {
  return <p aria-live={tone === 'error' ? 'assertive' : 'polite'} className={`dd-status-toast is-${tone}`} role={tone === 'error' ? 'alert' : 'status'}>{children}</p>;
}
